import React, { Component, Fragment } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithTranslation, withTranslation } from 'react-i18next';
import { ILinkedinsProps } from '../../../interfaces/props/ILinkedinDetailsProps';
import { linkedinsService } from '../../../services';
import ReactPlayer from 'react-player';
import { ILinkedinMedia, ILinkedin } from '../../../common/model/linkedin.model';
import { IElementLog } from '../../../common/model/log.model';
import moment from 'moment';
import './linkedin.scss';
import defaultImage from '../../../assets/images/no_image.jpg';

import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { Button } from 'react-bootstrap';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { notifySuccess, notifyError } from '../../../utils/toast.utils';

import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface ILinkedinReadMore {
  readMoreToggle: (linkedin: ILinkedin) => void;
  spinnerRequestMoreData: (linkedinId: string, showSpinner: boolean) => void;
  setNumPagesToDocument: (linkedinId: string, linkedinMediaId: string, numberPage: number) => void;
  setCurrentPageToDocument: (linkedinId: string, linkedinMediaId: string, pageNumber: number) => void;
}

type LinkedinPropsType = ILinkedinsProps & ILinkedinReadMore & RouteComponentProps & WithTranslation;

class Linkedin extends Component<LinkedinPropsType> {
  private readonly moreDataTextComponent = React.createRef<TextBoxComponent>();

  public registerLog(linkedinId: string): void {
    const {
      userId,
      companyId
    } = this.props;

    if (companyId !== undefined && companyId != null) {
      const linkedinLog: IElementLog = { linkedinId: linkedinId, userId: userId, companyId: companyId, date: moment() };

      linkedinsService.createLog(linkedinLog)
        .then(() => console.log(`Log Registered to Post Id=[${linkedinId}]`))
        .catch((err) => console.error(`Error to Log Registered to Post Id=[${linkedinId}]. Error: ${err}`));
    }
  }

  public async onPlay(linkedinId: string): Promise<void> {
    this.registerLog(linkedinId);
  }

  public async requestMoreData(linkedinId: string, text: string): Promise<void> {
    const {
      i18n,
      spinnerRequestMoreData
    } = this.props;

    spinnerRequestMoreData(linkedinId, true);

    linkedinsService
      .requestMoreData({ id: linkedinId, text: text !== undefined && text != null ? text : i18n.t('linkedin.defaultRequestMoreDataText') })
      .then(() => {
        spinnerRequestMoreData(linkedinId, false);
        notifySuccess(i18n.t('linkedin.successRequestMoreData'));
      })
      .catch(() => {
        spinnerRequestMoreData(linkedinId, false);
        notifyError(i18n.t('linkedin.errors.cannotRequestMoreData'));
      });
  }

  private getImageGallery(postId: string, medias: ILinkedinMedia[]): JSX.Element {
    const images = medias.filter((item) => {
        return item.type === 'IMAGE'
      })
      .map(function (obj) {
        const item = {
          key: postId + "_IMAGE_" + obj.id,
          original: obj.url,
          thumbnail: obj.url
        };

        return item;
      });

    return <div key={postId + '_ALL_IMAGE'}>
      <ImageGallery
        key={postId + '_ALL_IMAGE_IG'}
        items={images}
        showNav={images.length > 1}
        autoPlay={false}
        infinite={images.length > 1}
        showIndex={images.length > 1}
        showBullets={images.length > 1}
        showThumbnails={false}
        showPlayButton={false}
        showFullscreenButton={false}
        onErrorImageURL={defaultImage}
      />
    </div>;
  }

  private getVideo(postId: string, medias: ILinkedinMedia[]): JSX.Element {
    const videos = medias.filter((item) => {
        return item.type === 'VIDEO'
      })
      .map((obj) => {
        return <div key={postId + '_VIDEO_' + obj.id} className={ 'video' }>
          <ReactPlayer
            url={obj.url}
            controls={true}
            // Disable download button
            config={{ file: { attributes: { controlsList: 'nodownload' } } }}
            // Disable right click
            onContextMenu={(e: any) => e.preventDefault()}
            light={'https://aitextextranetstrgpro.blob.core.windows.net/webinar/thumbnail-webinar.png'}
            width={500}
            height={300}
            onPlay={(): Promise<void> => this.onPlay(obj.id)}
          />
        </div>;
      });

    return <div key={postId + '_ALL_VIDEO'}>{videos}</div>;
  }

  private onDocumentLoadSuccess(linkedinId: string, linkedinMediaId: string, numPages: number): void {
    const {
      setNumPagesToDocument
    } = this.props;

    setNumPagesToDocument(linkedinId, linkedinMediaId, numPages);
  }

  private getPdfReader(postId: string, medias: ILinkedinMedia[]): JSX.Element {
    const {
      setCurrentPageToDocument
    } = this.props;

    const pdfs: JSX.Element[] = medias.map((media: ILinkedinMedia) =>
      <div key={postId + '_' + media.id}>
        <Document file={media.url} onLoadSuccess={(pdf: any) => this.onDocumentLoadSuccess(postId, media.id, pdf.numPages)} >
          {<Page pageNumber={media.pageNumber} />}
        </Document>
        {media.numPages > 1 &&
          <div className="pdfNavigators">
            <Button
              disabled={media.pageNumber <= 1}
              onClick={() => {
                this.registerLog(postId);
                setCurrentPageToDocument(postId, media.id, media.pageNumber - 1);
              }}
              className='pdfNavigators'
            >
              {'<'}
            </Button>
            <Button
              disabled={media.pageNumber === media.numPages}
              onClick={() => {
                this.registerLog(postId);
                setCurrentPageToDocument(postId, media.id, media.pageNumber + 1);
              }}
              className='pdfNavigators next'
            >
              {'>'}
            </Button>
          </div>}
      </div>);

    return <div key={postId + '_ALL_PDF'} className='pdf'>{pdfs}</div>;
  }

  public getMedias(postId: string, medias: ILinkedinMedia[]): JSX.Element {
    const mediaComponents: JSX.Element[] = [];
    const defaultImageUrl = './content/defaultImageNews.png';

    if (medias === undefined || medias == null || medias.length === 0) {
      const media: ILinkedinMedia = {
        id: 'aitexBuilding_' + postId,
        url: defaultImageUrl,
        type: 'IMAGE',
        html: '',

        urlExpiresAt: BigInt(123),
        active: true
      };

      medias = [media];
    }

    const imageMedias = medias.filter((item) => item.type === 'IMAGE');
    if (imageMedias && imageMedias.length > 0) {
      mediaComponents.push(this.getImageGallery(postId, imageMedias));
    }

    const videoMedias = medias.filter((item) => item.type === 'VIDEO');
    if (videoMedias && videoMedias.length > 0) {
      mediaComponents.push(this.getVideo(postId, videoMedias));
    }

    const pdfMedias = medias.filter((item) => item.type === 'PDF');
    if (pdfMedias && pdfMedias.length > 0) {
      mediaComponents.push(this.getPdfReader(postId, pdfMedias));
    }

    return <div className={'medias'} key={postId + '_ALL_MEDIA'}>{(mediaComponents && mediaComponents.length > 0 ? mediaComponents[0] : <></>)}</div>;
  }

  private removeHtmlTags(htmlText: string): string {
    return htmlText.replace(/<[^>]*>?/gm, '');
  }

  private getSplitHtmlText(htmlText: string): string {
    const lengthLimit = 175;

    const cleanText = this.removeHtmlTags(htmlText);
    const splitText = cleanText.length > lengthLimit ? cleanText.substring(0, lengthLimit) : cleanText;

    return splitText;
  }

  public render() {
    const { linkedin, isEven, i18n, readMoreToggle, spinnerRequestMoreData } = this.props;

    const splitHtmlText = this.getSplitHtmlText(linkedin.html);

    const info = <div key={'post_' + linkedin.id} className='generalDiv'>
      <div className={'marginBotton ' + (linkedin.readMore ? 'hide' : 'show')} id={'split_post_' + linkedin.id} >
        <div id={'split_post_' + linkedin.id} dangerouslySetInnerHTML={{ __html: splitHtmlText }}></div>
        <label className='labelShowMoreData' onClick={() => {
          if (!linkedin.readMore) {
            this.registerLog(linkedin.id);

            readMoreToggle(linkedin);
          }
        }}>{(linkedin.readMore ? '' : '[...]')}</label>
      </div>
      <div className={'marginBotton ' + (linkedin.readMore ? 'show' : 'hide')} id={'full_post_' + linkedin.id} >
        <div className='divPostHtml' dangerouslySetInnerHTML={{ __html: linkedin.html }}></div>
        <div className='divMakeComment'>
          <label className='labelMakeComment'>{i18n.t('linkedin.makeComment')}</label>
          <TextBoxComponent
            id={'requestMoreData_post_' + linkedin.id}
            name={'requestMoreData_post_' + linkedin.id}
            multiline={true}
            ref={this.moreDataTextComponent}
            placeholder={i18n.t('linkedin.defaultRequestMoreDataText')}/>
          <Button
            title={i18n.t('linkedin.actions.requestMoreData')}
            disabled={linkedin.showSpinner}
            variant='secondary'
            onClick={() => {
              spinnerRequestMoreData(linkedin.id, true);
              const text = this.moreDataTextComponent.current.value;
              const comment = (text !== undefined && text != null && text.length > 0 && text.trim() != '' ? text : i18n.t('linkedin.defaultRequestMoreDataText')); 
              this.requestMoreData(linkedin.id, comment);
            }}
          >
            <i className={linkedin.showSpinner ? 'spinner-border spinner-border-sm' : 'icon icon-app-action-send-email'} />
          </Button>
        </div>
      </div>
    </div>;

    return (<Fragment>
      {<div id={linkedin.id} className={'column margin ' + (isEven ? 'isLinkedinEven' : 'isLinkedinOdd')}>
        {this.getMedias(linkedin.id, linkedin.medias)}
        {info}
      </div>}
    </Fragment>
    );
  }
}

export default withRouter(withTranslation()(Linkedin));
